// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Cgph","large":"styles_large__35Ees"};